import styled from 'styled-components'
import { SPACING } from '../../../../../styles/theme'

export const RaterInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.sm};
`

export const ClickableAvatar = styled.button`
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 50%;
  transition:
    transform 0.15s ease,
    box-shadow 0.15s ease;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: scale(1.05);
  }
`

export const RaterDetails = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`
